<!--
BEDROCK Core
Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
-->

<!Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
-->

<!Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
-->

<template>

    <div class="sdev-empty">

        <p>{{ text }}</p>

    </div>

</template>

<script setup>

defineProps({
    text: String
})

</script>